<template>
    <v-overlay
        :value="showLoader"
        z-index="999"
    >
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "LoaderModal",
    computed: {
      ...mapGetters({
        'showLoader': 'isLoading'
      })
    }
  }
</script>
